import React, { ChangeEvent, HTMLAttributes, useCallback, useRef } from 'react';
import classnames from 'classnames';
import { t, dangerousHTML } from 'utils';
import styles from './RadiobuttonCard.module.scss';

export interface IRadiobuttonCard extends Omit<HTMLAttributes<HTMLDivElement>, 'onChange'> {
  label: string;
  value: string;
  description?: string;
  subtitle?: string;
  badge?: string;
  onChange?: (e: ChangeEvent) => void;
  isSubmitOnChange?: boolean;
  disabled?: boolean;
}

const RadiobuttonCard: React.FC<IRadiobuttonCard> = (props) => {
  const {
    label,
    value,
    description,
    className,
    subtitle,
    // badge,
    disabled,
    onChange = () => {},
    isSubmitOnChange = true,
    ...otherProps
  } = props;

  const buttonRef = useRef<HTMLInputElement>(null);
  const rootClassName = classnames(styles.root, className, {
    [styles.disabled]: disabled,
  });
  const inputClassName = classnames('visually-hidden', styles.input);

  const handleSubmit = useCallback(() => {
    if (isSubmitOnChange) {
      buttonRef.current?.click();
    }
  }, [isSubmitOnChange]);

  return (
    <div>
      <label className={rootClassName}>
        <input
          className={inputClassName}
          onChange={onChange}
          onClick={handleSubmit}
          type='radio'
          value={value}
          disabled={Boolean(disabled)}
          {...otherProps}
        />
        <span className={styles.label} />
        <span className={styles.title}>
          {t(label)}
          {subtitle && <span>:&nbsp;</span>}
          {subtitle && <span className={styles.subtitle}>{t(subtitle)}</span>}
          {/* {badge && (
            <span className={styles.badge}>
              {t(badge)}
            </span>
          )} */}
        </span>
        <span className={styles.description}>
          <span dangerouslySetInnerHTML={{ __html: dangerousHTML(t(description)) }} />
        </span>
      </label>
      <input ref={buttonRef} type='submit' className='visually-hidden' />
    </div>
  );
};

export default RadiobuttonCard;
